/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ConsultationStrictHttpResponse } from '../../consultation-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicationRequestModel } from '../../models/medication-request-model';

export interface MedicationRequestsEncounterFhirIdGet$Params {
  encounterFHIRId: string;
}

export function medicationRequestsEncounterFhirIdGet(http: HttpClient, rootUrl: string, params: MedicationRequestsEncounterFhirIdGet$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<Array<MedicationRequestModel>>> {
  const rb = new RequestBuilder(rootUrl, medicationRequestsEncounterFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('encounterFHIRId', params.encounterFHIRId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ConsultationStrictHttpResponse<Array<MedicationRequestModel>>;
    })
  );
}

medicationRequestsEncounterFhirIdGet.PATH = '/Medication/Requests/{encounterFHIRId}';
